import React, { ComponentProps } from "react";

export default function CopyIcon({
  fill,
  ...restProps
}: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      {...restProps}
    >
      <rect
        x="0.333984"
        y="2"
        width="7.33333"
        height="10"
        rx="2"
        fill={fill || "#667085"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.41992 1.41902C2.60378 1.3633 2.79884 1.33333 3.0009 1.33333H6.33423C7.4388 1.33333 8.33423 2.22876 8.33423 3.33333V9.33333C8.33423 9.53539 8.30427 9.73045 8.24854 9.91431C9.06977 9.6654 9.66757 8.90251 9.66757 8V2C9.66757 0.895431 8.77213 0 7.66756 0H4.33423C3.43172 0 2.66883 0.597794 2.41992 1.41902Z"
        fill={fill || "#667085"}
      />
    </svg>
  );
}
